import { Location } from 'react-router-dom';

export const getHomeIdPath = (location: Location) => {
  const stringId = location.pathname.split('/')[2];
  return parseInt(stringId, 10);
};
